import React, { FC } from "react"

interface IProps {
    title?: string
    color?: string
    lineName?: string | null
    distance?: string | null
    walkTime?: string | null
}

const MetroView: FC<IProps> = ({ title, color, lineName, distance, walkTime }) => {
    // Проверяем есть ли валидная дистанция (не null и не "-")
    const hasDistance = distance && distance !== "-" && distance.trim() !== ""
    // Проверяем есть ли время пешком
    const hasWalkTime = walkTime && walkTime.trim() !== ""

    return title && color ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <div
                    style={{ 
                        width: 10, 
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: color,
                        marginRight: 8,
                        flexShrink: 0
                    }} 
                />
                <span>{title}</span>
            </div>
            {lineName && (
                <div style={{ 
                    marginLeft: 18,
                    fontSize: 11,
                    color: "#9ca3af"
                }}>
                    {lineName}
                </div>
            )}
            {(hasDistance || hasWalkTime) && (
                <div style={{ 
                    display: "flex", 
                    alignItems: "center",
                    gap: 8,
                    marginLeft: 18,
                    fontSize: 11,
                    color: "#6b7280"
                }}>
                    {hasDistance && (
                        <span>{distance}</span>
                    )}
                    {hasWalkTime && (
                        <span>🚶 {walkTime}</span>
                    )}
                </div>
            )}
        </div>
    ) : null
}

export default MetroView